<template>
  <vx-card :title="id === null ? 'Cadastrar Grupo' : 'Editar Grupo'">
    <vs-tabs :color="colorx">
      <vs-tab label="Grupo">
        <div class="vx-row mb-6">
          <div class="vx-col w-1/2">
            <vs-input class="w-full" label="Nome de Exibição" v-model="display_name" />
          </div>
          <div class="vx-col w-1/2">
            <vs-input class="w-full" label="Nome Interno" v-model="name" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input class="w-full" label="Descrição" v-model="description" />
          </div>
        </div>
        <!--
          O seletor de Estabelecimento foi removido: roles.legal_entity_id existe na tabela
          desde 2022 mas nenhuma consulta do backend o lê. Manter o campo aqui anunciava uma
          segregação de perfil por clube que o sistema não aplica. Se perfis por clube forem
          implementados de verdade, o controle volta junto com a regra que o consome.
        -->
        <div class="flex justify-end">
          <b-button
            variant="primary"
            class="float-right mr-2"
            @click="create">
            <span class="align-middle">{{$t('save')}}</span>
          </b-button>
          <b-button
              variant="outline-secondary"
              class="float-right"
              @click="goBack">
              <feather-icon
                icon="CornerUpLeftIcon"
                class="mr-50"/>
              <span class="align-middle">{{$t('back')}}</span>
            </b-button>
        </div>
      </vs-tab>
      <vs-tab :label="$t('functionality.titles')" v-if="id !== null">

          <app-collapse accordion="true">
            <app-collapse-item :title="func.name" v-for="func in functionalityList" :key="func.id">
              <vs-table no-data=" " :data="func.permissions" :key="id">
                <template slot="thead">
                  <vs-th width="3%">
                    <b-form-checkbox :id="`func_id_${func.id}`"
                      v-on:change="selectPermissionsAll($event, func.id, func.permissions)"/>
                    </vs-th>
                  <vs-th width="5%">{{ $t('id') }}</vs-th>
                  <vs-th width="25%">{{ $t('name') }}</vs-th>
                  <vs-th width="20%">{{ $t('permissions_name') }}</vs-th>
                  <vs-th width="50%">{{ $t('description') }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :key="i"
                    v-for="(tr, i) in data">
                    <vs-td :data="data[i].id">
                      <b-form-checkbox :id="`permission_id_${data[i].id}`"
                        :vs-value="data[i].id"
                        :checked="data[i].checked"
                        v-on:change="selectPermission($event, func.id, data[i].id)"/>
                    </vs-td>
                    <vs-td :data="data[i].id">
                      <label>{{data[i].id}}</label>
                    </vs-td>
                    <vs-td :data="data[i].name">
                      <label>{{data[i].name}}</label>
                    </vs-td>
                    <vs-td :data="data[i].display_name">
                      <label>{{data[i].display_name}}</label>
                    </vs-td>
                    <vs-td :data="data[i].description">
                      <label>{{data[i].description}}</label>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </app-collapse-item>
          </app-collapse>
        <div class="vx-row mt-3">
          <div class="vx-col w-full">
            <b-button
                variant="outline-secondary"
                class="float-right"
                @click="goBack">
                <feather-icon
                  icon="CornerUpLeftIcon"
                  class="mr-50"/>
                <span class="align-middle">{{$t('back')}}</span>
              </b-button>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Permissões" v-if="id !== null">
        <div class="vx-row mb-6" style="padding-top: 30px">
          <div class="vx-col w-full">
            <div class="flex justify-end">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                @click="showModal = true">
                <feather-icon
                  icon="PlusIcon"
                  class="mr-50"/>
                <span class="align-middle">{{$t('add')}}</span>
              </b-button>
              <b-button
                variant="outline-secondary"
                class="float-right"
                @click="goBack">
                <feather-icon
                  icon="CornerUpLeftIcon"
                  class="mr-50"/>
                <span class="align-middle">{{$t('back')}}</span>
              </b-button>
            </div>

            <vs-divider />
            <Grid
              :ref="'grid'"
              :key="gridKey"
              :service="permissionService"
              route_name="permissions"
              :route_grid_path="permissionsRolePath"
              :route_delete_path="permissionsRolePath"
              order_column="name"
              hide_edit="true"
              :multipleSelect="true"
              @changedSelection="changedSelection"
              :delegate="{destroy: () => destroyPermissionRole}"></Grid>
              <div class="vx-row mr-2">
                <div class="vx-col w-full">
                  <b-button class="float-right"
                              variant="primary"
                              @click="confirmDeletePermissions"
                              v-if="enableActionDeletePermissions">
                    {{ $t('action.delete') }}
                  </b-button>
                </div>
              </div>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>

    <vs-popup title="Permissões" :active.sync="showModal">
      <Grid
        :multipleSelect="true"
        :service="permissionService"
        @changedSelection="changedSelection"
        route_name="permissions"
        hide_actions="true"
        v-if="showModal"></Grid>
        <div class="flex justify-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            @click="addPermissions">
            <feather-icon
              icon="PlusIcon"
              class="mr-50"/>
            <span class="align-middle">{{$t('add')}}</span>
          </b-button>
        </div>
    </vs-popup>
  </vx-card>
</template>

<script>
import {
  BForm, BButton, BFormGroup, BInputGroup, BFormTextarea, BFormCheckbox, BCardText, BFormInput, BCard, BCardHeader, BCardTitle, BCardSubTitle, BCardBody, BCollapse, VBToggle, VBTogglePlugin
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ComplexEditor from '@/components/ComplexEditor.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem'

import PermissionService from '@/services/api/PermissionService'
import RoleService from '@/services/api/RoleService'
import FunctionalityService from '@/services/api/FunctionalityService'

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardText,
    BFormInput,
    BFormCheckbox,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardBody,
    BCollapse,
    VBToggle,
    VBTogglePlugin,
    // validations
    ValidationProvider,
    ValidationObserver,
    ComplexEditor,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    id: null,
    name: '',
    display_name: '',
    description: '',
    roleService: null,
    permissionService: null,
    showModal: false,
    selectedPermissions: [],
    functionalityList: [],
    gridKey: 0,
  }),
  computed: {
    permissionsRolePath() {
      return `/roles/${this.id}`
    },
    enableActionDeletePermissions() {
      return this.selectedPermissions.length > 0
    }
  },
  methods: {
    gridRef() {
      return this.$refs['grid']
    },
     updateGridRefPermissions() {
      const grid = this.gridRef()
      if ('fetchGridData' in grid) {
        grid.fetchGridData()
      }
    },
    changedSelection(items) {
      this.selectedPermissions = items
    },
    addPermissions() {
      if (this.id) {
        this.$vs.loading()
        this.roleService.attachPermissions(this.id, this.selectedPermissions).then(
          (response) => {
            this.showModal = false
            const grid = this.gridRef()
            if ('fetchGridData' in grid) {
              grid.fetchGridData()
            }
            this.notifySuccess(this.$vs, 'Permissões adicionadas com sucesso!')
            this.$vs.loading.close()
          },
          (error) => {
            this.notifyError(this.$vs, 'Houve um erro ao adicionar as permissões ao grupo.')
            this.$vs.loading.close()
          }
        )
      }
    },
    addPermissionsByFunctionality(functionalityId, permissionsList) {
      if (this.id) { //this.id = role id
        this.roleService.attachPermissions(this.id, permissionsList).then(
          (response) => {
            this.notifySuccess(this.$vs, this.$t('messages.success'))
            this.$vs.loading.close()
          },
          (error) => {
            this.notifyError(this.$vs, this.$t('messages.error'))
            this.$vs.loading.close()
          }
        )
      }
    },
    deletePermissionsByRole(permissionsList) {
      if (this.id) { //this.id = role id
        this.roleService.destroyPermissions(this.id, permissionsList).then(
          (response) => {
            this.$vs.notify({
              title: 'Successo!',
              text: this.$t('messages.success'),
              color: 'success',
              iconPack: 'feather',
              position: 'top-center',
              icon: 'icon-check-circle'
            })
            this.selectedPermissions = []
            this.updateGridRefPermissions()
            this.$vs.loading.close()
          },
          (error) => {
            this.notifyError(this.$vs, this.$t('messages.error'))
            this.$vs.loading.close()
          }
        )
      }
    },
    selectAll() {
      if (this.permissionService)  {
        this.$vs.loading()
        return this.permissionService.selectAll().then(
          (response) => {
            this.$vs.loading.close()

            return this._.isArray(response) ? response : []
          },
          (error) => {
            this.$vs.loading.close()
            return []
          }
        )
      }
    },
    itemSelected(permission) {
      const permissionIndex = this.selectedPermissions.findIndex((_permission) => _permission === permission.id)

      if (permissionIndex !== -1) {
        const newArray = this._.cloneDeep(this.selectedPermissions)
        newArray.splice(permissionIndex, 1)
        this.selectedPermissions = newArray
      } else {
        this.selectedPermissions.push(permission.id)
      }

    },
    destroyPermissionRole(permission) {
      this.$vs.loading()
      return this.permissionService.destroyPermissionRole(permission.id, this.id).then(
        response => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Successo!',
            text: 'Operação realizada com sucesso.',
            color: 'success',
            iconPack: 'feather',
            position: 'top-center',
            icon: 'icon-check-circle'
          })

          return {
            reload: true
          }
        },
        error => {
          this.$vs.loading.close()
          this.notifyError(this.$vs, 'Não foi possível remover esta permissão!')
        }
      )
    },
    create() {
      this.clearErrors(this.$validator)
      this.$vs.loading()

      this.roleService.createOrUpdate({
          id: this.id,
          name: this.name,
          display_name: this.display_name,
          description: this.description
        })
        .then(data => {
            this.$vs.loading.close()

            this.$vs.notify({
              title: 'Successo!',
              text: 'Operação realizada com sucesso.',
              color: 'success',
              iconPack: 'feather',
              position: 'top-center',
              icon: 'icon-check-circle'
            })

            this.$router.push(`/roles/${data.id}/edit`)
          },
          error => {
            this.$vs.loading.close()
            this.showErrors(this.$validator, error)
          }
        )
    },
    goBack() {
      this.$router.push('/roles')
    },
    getData(id) {
      this.$vs.loading()
      this.roleService.read(id).then(
        data => {
          this.$set(this.$data, 'id', data.id)
          this.$set(this.$data, 'name', data.name)
          this.$set(this.$data, 'display_name', data.display_name)
          this.$set(this.$data, 'description', data.description)
          this.$vs.loading.close()
        },
        error => {
          this.$vs.loading.close()
        }
      )
    },
    getFunctionalityList() {
      this.$vs.loading()
      this.functionalityService.listAllWithPermissions(this.id).then(
        data => {
          this.functionalityList = data
          this.$vs.loading.close()
        },
        error => {
          this.$vs.loading.close()
        }
      )
    },
    selectPermission(eventChecked, funcId, permissionId) {
      const permissionsId = [permissionId]
      if (eventChecked) {
        this.addPermissionsByFunctionality(funcId, permissionsId)
      } else {
        this.deletePermissionsByRole(permissionsId)
      }
    },
    selectPermissionsAll(eventChecked, funcId, permissionList) {
      const prefixId = '#permission_id_'
      if (eventChecked) {
        const ids = []
        permissionList.forEach((permission) => {
          ids.push(permission.id)
          const input = this.$el.querySelector(prefixId + permission.id)
          input.checked = true
        })

        this.addPermissionsByFunctionality(funcId, ids)
      } else {
        const ids = []
        permissionList.forEach((permission) => {
          const input = this.$el.querySelector(prefixId + permission.id)
          ids.push(permission.id)
          input.checked = false
        })

        this.deletePermissionsByRole(ids)
      }
    },
    confirmDeletePermissions() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: this.$t('confirmacao'),
        acceptText: this.$t('sim'),
        cancelText: this.$t('nao'),
        text: this.$t('messages.confirm_deletion'),
        accept: this.deletePermissions,
      })
    },
    deletePermissions() {
      this.deletePermissionsByRole(this.selectedPermissions)
    }
  },
  mounted() {
    /*
      this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      console.log('collapseId:', collapseId)
      console.log('isJustShown:', isJustShown)
    })*/
  },
  beforeMount() {
    this.roleService = RoleService.build(this.$vs)
    this.permissionService = PermissionService.build(this.$vs)
    this.functionalityService = FunctionalityService.build(this.$vs)

    if (this.id) {
      this.getData(this.id)
      this.getFunctionalityList()
    }
  },
}
</script>


<style lang="scss" scoped>
::v-deep .vs-popup {
  width: 800px !important;
}

.accordion {
    overflow-anchor: none;
}
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
